// Google Ads Conversion Tracking Helper
// Replace 'AW-XXXXXXXXX' with your actual Google Ads ID
// Replace 'AW-XXXXXXXXX/CONVERSION_LABEL' with your conversion label

export const GA_ADS_ID = 'AW-XXXXXXXXX';

// Track page view
export const trackPageView = (url: string) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_ADS_ID, { page_path: url });
  }
};

// Track phone call conversion
export const trackPhoneCall = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-XXXXXXXXX/CALL_CONVERSION_LABEL',
      event_callback: () => {},
    });
  }
};

// Track form submission conversion
export const trackFormSubmission = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-XXXXXXXXX/FORM_CONVERSION_LABEL',
      event_callback: () => {},
    });
  }
};

// Track WhatsApp click
export const trackWhatsAppClick = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-XXXXXXXXX/WHATSAPP_CONVERSION_LABEL',
      event_callback: () => {},
    });
  }
};

// Declare gtag on window
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}
